<template>
    <div id="root">
        <div :class="cssClasses">
            <component
                :is="$route.meta.layout"
                :is-x-small="screen.getScreenSizeInfo.isXSmall"
                :is-large="screen.getScreenSizeInfo.isLarge"
            >
                <div>
                    <router-view></router-view>
                </div>
            </component>
        </div>
        <ZaloChatHelperVue v-if="!isMobile" />
    </div>

    <DxPopup
        v-if="ifPopupThongBao"
        v-model:visible="PopupThongBao"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        :width="widthPopup || 424"
        height="auto"
        maxHeight="calc(100vh - 96px)"
        @hidden="onHidden('PopupThongBao')"
        :onShown="onShown"
    >
        <DxScrollView ref="DxScrollViewThongBao" width="100%" height="100%">
            <NotificationVue
                :Params="ParamsThongBao"
                :ButtonLeft="UsingButtonLeft"
                @click="XacNhanThongBao"
            />
        </DxScrollView>
    </DxPopup>
</template>

<script>
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import {
    getCurrentInstance,
    reactive,
    onMounted,
    onBeforeUnmount,
    computed,
} from "vue";
import ZaloChatHelperVue from "./components/Socials/ZaloChatHelper.vue";
import { DxPopup, DxScrollView } from "devextreme-vue";
import NotificationVue from "@sonphat/common-v1/components/Notification.vue";

function getScreenSizeInfo() {
    const screenSizes = sizes();

    return {
        isXSmall: screenSizes["screen-x-small"],
        isLarge: screenSizes["screen-large"],
        cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
    };
}

export default {
    setup() {
        const vm = getCurrentInstance();

        const title = vm.proxy.$appInfo.title;
        const screen = reactive({ getScreenSizeInfo: {} });
        screen.getScreenSizeInfo = getScreenSizeInfo();

        function screenSizeChanged() {
            screen.getScreenSizeInfo = getScreenSizeInfo();
        }

        onMounted(() => {
            subscribe(screenSizeChanged);
        });

        onBeforeUnmount(() => {
            unsubscribe(screenSizeChanged);
        });

        const cssClasses = computed(() => {
            return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
        });

        return {
            title,
            screen,
            cssClasses,
        };
    },
    components: { ZaloChatHelperVue, DxPopup, NotificationVue, DxScrollView },
    data() {
        return {
            checkLoading: 0,
            ifPopupThongBao: false,
            PopupThongBao: false,
            ParamsThongBao: {
                state: "Error",
                button_save: "Đồng ý",
                button_cancel: "Hủy",
                title: "Cảnh báo!",
                message_title: "Bạn muốn thoát khỏi hệ thống?",
                statusCode: 0,
            },
            UsingButtonLeft: false,
            widthPopup: 424,
        };
    },
    computed: {
        isMobile: {
            get() {
                return this.$store.state.ManHinh.isMobile;
            },
            set(data) {
                this.$store.commit("ManHinh/Set", {
                    key: "isMobile",
                    data: data,
                });
            },
        },
    },
    watch: {
        checkLoading() {
            if (this.checkLoading == 0) {
                this.$hideLoading;
            }
            if (this.checkLoading > 0) {
                this.$showLoading;
            }
            if (this.checkLoading < 0) {
                this.checkLoading = 0;
            }
        },
    },
    methods: {
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        XacNhanThongBao(bool) {
            if (bool == false) {
                this.PopupThongBao = false;
            }
            if (bool == true) {
                this.PopupThongBao = false;
                this.emitter.emit("XacNhanThongBao", bool);
                if (this.ParamsThongBao.statusCode == -1) {
                    this.XacNhanCapNhatPhienBanMoi();
                }
            }

            if (this.ParamsThongBao.statusCode == 401) {
                this.$Core.Auth.Logout();
            }
        },
        onShown(e) {
            const scrollViewInstance = this.$refs.DxScrollViewThongBao.instance;
            scrollViewInstance.option(
                "height",
                e.component._$content[0].clientHeight - 48
            );
            scrollViewInstance.update();
        },
        windowKeydown(keydown) {
            if (!this.PopupThongBao) {
                return;
            } else if (
                this.PopupThongBao &&
                keydown.keyCode == parseInt(this.$t("keyCode.Enter"))
            ) {
                this.XacNhanThongBao(true);
                return;
            } else if (
                this.PopupThongBao &&
                keydown.keyCode == parseInt(this.$t("keyCode.Esc"))
            ) {
                this.XacNhanThongBao(false);
                return;
            }
        },
        connectServicesWorker() {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.addEventListener("message", (event) => {
                    if (
                        event.data.message == "isNewVersion" &&
                        event.data.keyApp == "ThongTin"
                    ) {
                        this.UsingButtonLeft = true;
                        this.ParamsThongBao.state = "Warning";
                        this.ParamsThongBao.button_save = "Đồng ý";
                        this.ParamsThongBao.title = "Thông báo!";
                        this.ParamsThongBao.message_title =
                            "Đã có bản cập nhật mới!";
                        this.ParamsThongBao.message = `Vui lòng tải lại trang ở tất cả các cửa sổ(tab) phần mềm nhận được thông báo này để cập nhật phiên bản mới nhất của hệ thống!\nNếu không có thể dẫn đến lỗi do sử dụng không đồng nhất phiên bản!`;
                        this.ParamsThongBao.statusCode = -1;
                        this.showPopup("PopupThongBao");
                    }
                    navigator.serviceWorker.ready.then((workerRegistration) => {
                        workerRegistration.active.postMessage({
                            message: "checkNewVersion",
                        });
                    });
                });
            }
        },
        XacNhanCapNhatPhienBanMoi() {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            });
            location.reload();
        },
        LayThongTinTrinhDuyet() {
            let width = document.querySelector("html").clientWidth;
            if (width < 488) {
                this.isMobile = true;
            }
        },
    },
    mounted() {
        let self = this;
        this.LayThongTinTrinhDuyet();
        this.connectServicesWorker();
        this.emitter.on("startLoading", () => {
            self.checkLoading++;
        });
        this.emitter.on("stopLoading", () => {
            self.checkLoading--;
        });
        this.emitter.on("resetLoading", () => {
            self.checkLoading = 0;
        });
        this.emitter.on(
            "ThongBaoPopup",
            ({
                type = "error",
                title = "Thông báo",
                message_title = "",
                message = "",
                textButton = "Đồng ý",
                statusCode = 0,
                widthPopup = 424,
            }) => {
                self.UsingButtonLeft = false;
                self.ParamsThongBao.state = type;
                self.ParamsThongBao.button_save = textButton;
                self.ParamsThongBao.title = title;
                self.ParamsThongBao.message_title = message_title;
                self.ParamsThongBao.message = message;
                self.ParamsThongBao.statusCode = statusCode;
                self.widthPopup = widthPopup;
                self.showPopup("PopupThongBao");
                setTimeout(() => {
                    let elm = document.getElementById("btnThongBao-Ok");
                    setTimeout(() => {
                        elm.focus();
                    }, 200);
                }, 300);
            }
        );
        window.addEventListener("keydown", this.windowKeydown, false);
    },
};
</script>

<style lang="scss">
html,
body {
    margin: 0px;
    min-height: 100%;
    height: 100%;
}

#root {
    height: 100%;
}

* {
    box-sizing: border-box;
}

.app {
    @import "./themes/generated/variables.base.scss";
    background-color: darken($base-bg, 5);
    display: flex;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
}
</style>
